<div class="acl-denied-modal">
    <div class="modal-header">
        <div class="status-icon">
            <mat-icon>lock</mat-icon>
        </div>
        <h2 mat-dialog-title>Login Access Restricted</h2>
    </div>

    <mat-dialog-content>
        <p class="message">
            Your current network is not permitted by your organization's login access policy.
            Please contact your administrator if you need access from this location.
        </p>

        <div class="source-ip" *ngIf="data?.sourceIp">
            <span>Detected source IP</span>
            <strong>{{data.sourceIp}}</strong>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="close()">OK</button>
    </mat-dialog-actions>
</div>
